import Class from './c-tab';
import './c-tab@';

export default Class;